import React, { memo, useCallback } from "react";

import type { Locale } from "../types";
import localization from "../localization";

import { Slider } from "@mui/material";

type SliderComponentProps = {
  locale: Locale;
  value: number;
  label: string;
  step: number;
  min: number;
  max: number;
  handleChange: (event: Event, value: number | number[], activeThumb: number) => void;
  handleChangeCommited: (
    event: Event | React.SyntheticEvent<Element, Event>,
    value: number | number[],
  ) => void;
};

const SliderComponent = memo((props: SliderComponentProps) => {
  const { locale, value, label, step, min, max, handleChange, handleChangeCommited } = props;

  const { localeString, currency } = localization[locale];

  const handleValueLabelFormat = useCallback(
    (value: number) =>
      new Intl.NumberFormat(localeString, {
        style: "currency",
        currency,
      }).format(value),
    [],
  );

  return (
    <Slider
      size="small"
      value={value}
      aria-label={label}
      valueLabelDisplay="auto"
      step={step}
      min={min}
      max={max}
      valueLabelFormat={handleValueLabelFormat}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommited}
    />
  );
});

export default SliderComponent;
